export function formatMissionType(type: string): string {
  const map: Record<string, string> = {
    SCENE_CALL: 'Scene Call',
    INTER_FACILITY: 'Inter-Facility',
    STANDBY: 'Standby',
    TRAINING: 'Training',
    REPATRIATION: 'Repatriation',
    TELEHEALTH: 'Telehealth',
  };
  return map[type] || type.replace(/_/g, ' ');
}

export function formatMissionStatus(status: string): string {
  const map: Record<string, string> = {
    RECEIVED: 'Received',
    ASSIGNED: 'Assigned',
    DISPATCHED: 'Dispatched',
    CREW_NOTIFIED: 'Crew Notified',
    AIRCRAFT_NOTIFIED: 'Aircraft Notified',
    AIRCRAFT_LAUNCHED: 'Aircraft Launched',
    AIRCRAFT_AT_CREW_BASE: 'Aircraft at Crew Base',
    CREW_ABOARD: 'Crew Aboard',
    ENROUTE_TO_SCENE: 'Enroute to Scene',
    ON_SCENE: 'On Scene',
    PATIENT_CONTACT: 'Patient Contact',
    TRANSPORTING: 'Transporting',
    AT_DESTINATION: 'At Destination',
    MISSION_COMPLETE: 'Mission Complete',
    CANCELLED: 'Cancelled',
    STANDBY: 'Standby',
    CLOSED: 'Closed',
  };
  return map[status] || status.replace(/_/g, ' ');
}

export function formatPriority(priority: string): string {
  const map: Record<string, string> = {
    CRITICAL: 'Critical',
    URGENT: 'Urgent',
    ROUTINE: 'Routine',
  };
  return map[priority] || priority;
}

/**
 * Human-friendly timestamp: "3 min ago", "2h ago", "Yesterday 14:30", "Mar 10, 14:30"
 */
export function formatTimeAgo(date: Date | string | null | undefined): string {
  if (!date) return '--';
  const d = new Date(date);
  const now = new Date();
  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  const diffHrs = Math.floor(diffMs / 3600000);

  if (diffMin < 1) return 'Just now';
  if (diffMin < 60) return `${diffMin} min ago`;
  if (diffHrs < 24) {
    const h = d.getHours().toString().padStart(2, '0');
    const m = d.getMinutes().toString().padStart(2, '0');
    return `${diffHrs}h ago (${h}:${m})`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday = d.toDateString() === yesterday.toDateString();
  const h = d.getHours().toString().padStart(2, '0');
  const m = d.getMinutes().toString().padStart(2, '0');

  if (isYesterday) return `Yesterday ${h}:${m}`;

  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const isSameYear = d.getFullYear() === now.getFullYear();
  if (isSameYear) return `${months[d.getMonth()]} ${d.getDate()}, ${h}:${m}`;
  return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()} ${h}:${m}`;
}
